import { BaseballIncidentId } from '@collector/sportsapi-client-legacy'
import { Incident } from '@collector/sportsapi-types'

import { IncidentsCustomFiltersConfig } from '../../configuration'

export const incidentsCustomFiltersConfig: IncidentsCustomFiltersConfig = {
  filters: [
    {
      customName: 'Hide throw pitcher',
      filterFunction: (incident: Incident) =>
        incident.incident_id !== BaseballIncidentId.ThrowPitcher,
    },
  ],
}
